import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationModalComponent } from './shared/components/notification-modal/notification-modal.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NotificationModalComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'Distrident Ecommerce';
}
